import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Btn, H3 } from "../../AbstractElements";
import {
  Col,
  Container,
  Row,
  CardBody,
  Card,
  CardHeader,
  Table,
} from "reactstrap";
import Papa from "papaparse";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { toast } from "react-toastify";
import AWS from "aws-sdk";
import moment from "moment";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  S3_BUCKET,
  REGION,
  IMPORT,
  FAILED,
  FILES,
  limit,
  ASSETIMPORT_S3_BUCKET,
} from "../../Config/Config";
import { generateClient } from "aws-amplify/api";
const XLSX = require("xlsx");
const base64 = require("base-64");

const client = generateClient({
  headers: {
    "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
  },
});

// allowed columns for import (unchanged)
const ASSET_COLUMNS = [
  "siteName",
  "distributionboard",
  "assetDescription",
  "assetLocation",
  "assetMake",
  "assetModel",
  "fittingNumber",
  "assettemplate",
  "assetWarrantyStart",
  "assetWarrantyEnd",
  "installedOn",
  "FittingId",
  "duplicate",
  "siteId",
  "sitedetailsID",
  "logbookId",
  "assetOwnerID",
  "assettemplateID",
  "assetType",
  "assettemplateSiteID",
];

AWS.config.update({
  accessKeyId: process.env.REACT_APP_ACCESSKEYID,
  secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY,
});

const s3Client = new AWS.S3({
  params: { Bucket: S3_BUCKET },
  region: REGION,
});

const LogbookAssetDetails = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || null;

  // Minimal state - we only keep what's required
  const [fileData, setFileData] = useState([]);
  const [fileHeader, setFileHeader] = useState([]);
  const [tableColumnLength, setTableColumnLength] = useState([]);
  const [siteDetails, setSiteDetails] = useState([]);
  const [distributionBoard, setDistributionBoard] = useState([]);
  const [assetTemplateId, setAssetTemplateId] = useState([]);
  const [assetByTemplates, setAssetByTemplates] = useState([]);
  const [logbooks, setLogbooks] = useState([]);
  const [errorMessage, setErrorMessage] = useState(false);
  const [errorMessage1, setErrorMessage1] = useState(false);
  const [dbError, setDBError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filename, setFilename] = useState(null);
  const [fileExt, setFileExt] = useState("");
  const [maxNum, setMaxNum] = useState(0);
  const [email, setEmail] = useState("");
  const [importlogid, setImportlogid] = useState("");
  const [sitesFromFile1, setSitesFromFile1] = useState([]);

  // derived values
  const LoginUserDetails = useMemo(
    () => JSON.parse(localStorage.getItem("userDetails") || "{}"),
    [],
  );
  const LoginUserGroup = localStorage.getItem("groups");

  /*******************
   * Utility helpers
   *******************/
  const paginateFetchAll = useCallback(async (query, variables = {}) => {
    // Generic paginator that returns concatenated items (if query returns { items, nextToken })
    try {
      const merged = [];
      let nextToken = variables.nextToken || null;
      do {
        const resp = await client.graphql({
          query,
          variables: { ...variables, nextToken },
          authMode: "API_KEY",
        });
        // try to find the nested field dynamically (first prop of data)
        const dataRoot = resp?.data ? Object.values(resp.data)[0] : null;
        if (!dataRoot) break;
        const items = dataRoot.items || [];
        nextToken = dataRoot.nextToken;
        if (items && items.length > 0) merged.push(...items);
      } while (nextToken !== null);
      return merged;
    } catch (err) {
      console.error("paginateFetchAll error:", err);
      return [];
    }
  }, []);

  const uploadToS3 = useCallback(async ({ bucket, key, fileObj }) => {
    // returns a promise that resolves when upload completes
    return new Promise((resolve, reject) => {
      const params = {
        ACL: "public-read",
        Body: fileObj,
        Bucket: bucket,
        Key: key,
      };
      s3Client
        .putObject(params)
        .on("httpUploadProgress", (evt) => {
          // optional: console.log(evt);
        })
        .send((err) => {
          if (err) {
            console.error("S3 upload error:", err);
            return reject(err);
          }
          resolve(true);
        });
    });
  }, []);

  /*******************
   * Fetchers
   *******************/
  const fetchSiteDetailsAO = useCallback(async () => {
    try {
      const items = await paginateFetchAll(queries.siteDetailsByAssetownerID, {
        assetownerID: LoginUserDetails.id,
        limit: 200000,
      });
      if (items.length > 0) {
        const active = items.filter((it) => it.status === "Active");
        setSiteDetails(active);
        localStorage.setItem("site", base64.encode(JSON.stringify(items)));
      }
    } catch (err) {
      console.error("fetchSiteDetailsAO:", err);
      setSiteDetails([]);
    }
  }, [LoginUserDetails.id, paginateFetchAll]);

  const fetchSiteDetailsSU = useCallback(async () => {
    // For site_user: linkUsersAndSitesByUserdetailsID => getSiteDetails per link
    try {
      const linked = await client.graphql({
        query: queries.linkUsersAndSitesByUserdetailsID,
        variables: { userdetailsID: LoginUserDetails.id, limit },
        authMode: "API_KEY",
      });
      const items = linked?.data?.linkUsersAndSitesByUserdetailsID?.items || [];
      if (!items.length) {
        setSiteDetails([]);
        return;
      }
      // fetch each site details
      const promises = items.map((it) =>
        client.graphql({
          query: queries.getSiteDetails,
          variables: { id: it.sitedetailsID },
          authMode: "API_KEY",
        }),
      );
      const results = await Promise.all(promises);
      const siteList = results
        .map((r) => r?.data?.getSiteDetails)
        .filter(Boolean);
      setSiteDetails(siteList);
      // get templates for these sites later in flow (caller handles)
      return siteList;
    } catch (err) {
      console.error("fetchSiteDetailsSU:", err);
      setSiteDetails([]);
      return [];
    }
  }, [LoginUserDetails.id]);

  const getDistributionBoardFromActiveSites = useCallback(
    async (activeSites) => {
      try {
        if (!activeSites || !activeSites.length) return [];
        // fetch distribution boxes for each site and concat
        const dbPromises = activeSites.map((site) =>
          paginateFetchAll(queries.distributionBoxesBySitedetailsID, {
            sitedetailsID: site.id,
          }),
        );
        const dbsNested = await Promise.all(dbPromises);
        const merged = dbsNested.flat();
        if (merged.length > 0) {
          setDistributionBoard(merged);
          localStorage.setItem("siteDB", base64.encode(JSON.stringify(merged)));
        } else {
          setDistributionBoard([]);
        }
        return merged;
      } catch (err) {
        console.error("getDistributionBoardFromActiveSites:", err);
        return [];
      }
    },
    [paginateFetchAll],
  );

  const fetchAssetsData = useCallback(async () => {
    try {
      const resp = await client.graphql({
        query: queries.assetsByTypeAndAssetNum,
        authMode: "API_KEY",
        variables: {
          limit,
          type: "Assets",
          sortDirection: "DESC",
        },
      });
      const items = resp?.data?.assetsByTypeAndAssetNum?.items || [];
      if (items.length > 0) {
        const max = items[0].assetNum || 0;
        setMaxNum(parseInt(max, 10) + 1);
      }
    } catch (err) {
      console.error("fetchAssetsData:", err);
    }
  }, []);

  const fetchLogbooks = useCallback(async () => {
    try {
      const result = await client.graphql({
        query: queries.listLogBooks,
        variables: { filter: { status: { eq: "Active" } }, limit },
        authMode: "API_KEY",
      });
      setLogbooks(result?.data?.listLogBooks?.items || []);
    } catch (err) {
      console.error("fetchLogbooks:", err);
      setLogbooks([]);
    }
  }, []);

  const fetchEmailId = useCallback(async () => {
    try {
      if (LoginUserGroup === "site_user") {
        const result = await client.graphql({
          query: queries.getSPUserDetails,
          variables: { id: LoginUserDetails.id, limit },
          authMode: "API_KEY",
        });
        const emailVal = result?.data?.getSPUserDetails?.email || "";
        setEmail(emailVal);
      } else {
        const result = await client.graphql({
          query: queries.getAssetOwner,
          variables: { id: LoginUserDetails.id, limit },
          authMode: "API_KEY",
        });
        const emailVal = result?.data?.getAssetOwner?.email || "";
        setEmail(emailVal);
      }
    } catch (err) {
      console.error("fetchEmailId:", err);
    }
  }, [LoginUserDetails.id, LoginUserGroup]);

  const getAssetsByTemplates = useCallback(
    async (assetTemplates, siteData) => {
      // For each template and site, fetch assets (paginated), merge and set
      try {
        setIsLoading(true);
        const resultPromises = [];
        for (const template of assetTemplates) {
          for (const site of siteData) {
            const tempSiteId = `${template.id}_${site.id}`;
            const p = paginateFetchAll(
              queries.assetsByAssettemplateSiteIDAndAssetNum,
              {
                assettemplateSiteID: tempSiteId,
                limit,
                filetr: { status: { ne: "delete" } },
              },
            );
            resultPromises.push(p);
          }
        }
        const nested = await Promise.all(resultPromises);
        const merged = nested.flat();
        setAssetByTemplates(merged);
      } catch (err) {
        console.error("getAssetsByTemplates:", err);
        setAssetByTemplates([]);
      } finally {
        setIsLoading(false);
      }
    },
    [paginateFetchAll],
  );
  const getAssetTemplate = useCallback(
    async (sites) => {
      // fetch asset templates for the category
      try {
        const result = await client.graphql({
          query: queries.assetTemplatesByCategoriesID,
          variables: {
            categoriesID: state?.category?.id,
            filter: { status: { eq: "Active" } },
            limit,
          },
          authMode: "API_KEY",
        });
        const items = result?.data?.assetTemplatesByCategoriesID?.items || [];
        setAssetTemplateId(items);
        if (items.length && sites && sites.length) {
          await getAssetsByTemplates(items, sites);
        }
      } catch (err) {
        console.error("getAssetTemplate:", err);
        setAssetTemplateId([]);
      }
    },
    [state, getAssetsByTemplates],
  );

  /*******************
   * Distribution Board / append helpers
   *******************/
  const appendDistributionBoard = useCallback(async (createdResults) => {
    // createdResults is the array returned from createDistributionBox mutation responses
    try {
      const updates = [];
      for (const res of createdResults) {
        if (!res || !res.data || !res.data.createDistributionBox) continue;
        const id = res.data.createDistributionBox.id;
        // fetch created DB details
        const getResp = await client.graphql({
          query: queries.getDistributionBox,
          variables: { id },
          authMode: "API_KEY",
        });
        const dbEntry = getResp?.data?.getDistributionBox;
        if (dbEntry) updates.push(dbEntry);
      }
      if (updates.length > 0) {
        // merge with existing localStorage if present
        const existing = localStorage.getItem("siteDB");
        const activeDB = existing ? JSON.parse(base64.decode(existing)) : [];
        const merged = [...activeDB, ...updates];
        setDistributionBoard(merged);
        localStorage.setItem("siteDB", base64.encode(JSON.stringify(merged)));
      }
    } catch (err) {
      console.error("appendDistributionBoard error:", err);
    }
  }, []);

  /*******************
   * File parsing helpers (CSV and Excel)
   *******************/
  const validateHeaders = useCallback((headers) => {
    // any header not in ASSET_COLUMNS must have prefix 'custom-'
    for (const h of headers) {
      if (h == null) continue;
      if (!ASSET_COLUMNS.includes(h) && !h.includes("custom-")) return false;
    }
    return true;
  }, []);

  const handleCSVParse = useCallback((file, onComplete) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (result) => {
        const rows = result.data || [];

        // mark duplicates (matching fittingNumber + distributionboard + siteName)
        rows.forEach((obj, idx) => {
          const dupIndex = rows.findIndex(
            (o) =>
              o.fittingNumber === obj.fittingNumber &&
              o.distributionboard === obj.distributionboard &&
              o.siteName === obj.siteName,
          );
          if (dupIndex !== idx)
            obj.duplicate =
              "Duplicate Fitting Number for Site and Distribution Board.";
        });

        const headers = Object.keys(rows[0] || {});
        onComplete({ rows, headers });
      },
      error: (err) => {
        console.error("CSV parse error:", err);
        onComplete({ error: err });
      },
    });
  }, []);

  const handleExcelParse = useCallback(async (file, onComplete) => {
    try {
      const reader = new FileReader();
      reader.onload = (event) => {
        try {
          const data = new Uint8Array(event.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          // header:1 returns arrays
          const rows = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
            blankrows: false,
            defval: null,
            raw: false,
            cellDates: true,
            dateNF: "mm/dd/yyyy",
          });
          // filter out fully empty rows
          const filteredRows = rows.filter(
            (r) => r && Object.values(r).some((v) => v !== null && v !== ""),
          );
          if (!filteredRows.length)
            return onComplete({ rows: [], headers: [] });
          const headers = filteredRows[0].slice();
          // ensure 'duplicate' header present
          if (!headers.includes("duplicate")) headers.push("duplicate");
          const dataRows = filteredRows.slice(1);
          // convert rows to objects
          const importData = [];
          for (const row of dataRows) {
            const obj = {};
            headers.forEach((h, i) => {
              obj[h] = row[i] !== undefined ? row[i] : null;
            });
            // skip rows that are completely empty
            if (!Object.keys(obj).every((k) => !obj[k])) importData.push(obj);
          }
          // convert objects to array-of-objects similar to CSV output
          onComplete({ rows: importData, headers });
        } catch (e) {
          console.error("Excel read inner error:", e);
          onComplete({ error: e });
        }
      };
      reader.readAsArrayBuffer(file);
    } catch (err) {
      console.error("Excel parse error:", err);
      onComplete({ error: err });
    }
  }, []);

  /*******************
   * File upload handler
   *******************/
  const handleFileUpload = useCallback(
    async (event) => {
      try {
        setIsLoading(true);
        setDBError("");
        const file = event.target.files[0];
        if (!file) {
          // reset states and show info
          setFileData([]);
          setFileHeader([]);
          setTableColumnLength([]);
          setIsLoading(false);
          toast.info("File not selected", {
            position: toast.POSITION.TOP_CENTER,
          });
          return;
        }
        setFilename(file);
        const filenameStr = file.name;
        const alphanumericRegex = /^[a-zA-Z0-9._\s]+$/;
        if (!alphanumericRegex.test(filenameStr)) {
          setIsLoading(false);
          setDBError("disabled");
          toast.error(
            "Filename must be alphanumeric and cannot contain special characters!",
            { position: toast.POSITION.TOP_CENTER },
          );
          return;
        }

        const ext = filenameStr.split(".").pop().toLowerCase();
        setFileExt(ext);

        const processParsed = async ({ rows = [], headers = [], error }) => {
          if (error) {
            console.error("File parse returned error:", error);
            setIsLoading(false);
            return;
          }

          const cleanedHeaders = headers.filter(Boolean).map((h) =>
            h
              .toString()
              .trim()
              .replace(/\uFEFF/g, ""),
          ); // remove hidden chars

          // ensure headers valid
          if (!validateHeaders(cleanedHeaders)) {
            setFileData([]);
            setFileHeader([]);
            setTableColumnLength([]);
            setErrorMessage(true);
            setIsLoading(false);
            return;
          }

          // Save header and data for preview
          setFileHeader(cleanedHeaders);
          setTableColumnLength(cleanedHeaders);
          setFileData(rows);
          if (errorMessage) setErrorMessage(false);

          // collect distribution board + site pairs for creation
          const dbPairs = [];
          const sitesFromFileLocal = new Set();
          for (const item of rows) {
            // for both csv & excel our rows are objects with keys as headers
            // normalize dates if present
            if (item.assetWarrantyStart)
              item.assetWarrantyStart = moment(item.assetWarrantyStart).format(
                "DD/MM/YYYY",
              );
            if (item.assetWarrantyEnd)
              item.assetWarrantyEnd = moment(item.assetWarrantyEnd).format(
                "DD/MM/YYYY",
              );
            if (item.installedOn)
              item.installedOn = moment(item.installedOn).format("DD/MM/YYYY");

            const dist = item.distributionboard;
            const site = item.siteName || item.site; // excel vs csv possible differences
            if (dist && dist.toString().toLowerCase() !== "unknown") {
              dbPairs.push({ db: dist.trim(), site: site ? site.trim() : "" });
            }
            if (site) sitesFromFileLocal.add(site.trim());
          }

          setSitesFromFile1(Array.from(sitesFromFileLocal));

          // dedupe pairs (preserve insertion order)
          const uniquePairs = Array.from(
            new Map(dbPairs.map((p) => [JSON.stringify(p), p])).values(),
          );

          // create missing distribution boxes: check against existing distributionBoard and siteDetails
          const createPromises = uniquePairs
            .map((pair) => {
              const siteMatch = siteDetails.find(
                (s) =>
                  s.siteName &&
                  s.siteName.toLowerCase().trim() ===
                    (pair.site || "").toLowerCase().trim(),
              );
              if (!siteMatch) return null;
              const dbExists = distributionBoard.find(
                (d) =>
                  d.distributionBoxName &&
                  d.distributionBoxName.toLowerCase() ===
                    (pair.db || "").toLowerCase() &&
                  d.sitedetailsID === siteMatch.id,
              );
              if (!dbExists) {
                return client.graphql({
                  query: mutations.createDistributionBox,
                  variables: {
                    input: {
                      distributionBoxName: pair.db,
                      sitedetailsID: siteMatch.id,
                      status: "Active",
                    },
                  },
                  authMode: "API_KEY",
                });
              }
              return null;
            })
            .filter(Boolean);

          if (createPromises.length > 0) {
            try {
              const results = await Promise.all(createPromises);
              if (results && results.length) {
                await appendDistributionBoard(results);
              }
            } catch (err) {
              console.error("createDistributionBox Promise.all error:", err);
              setErrorMessage("Unable to fetch the list");
              // special-case: Emergency Lights show toast
              if (state?.category?.categoryName === "Emergency Lights") {
                setDBError("disabled");
                toast.error(
                  "Distribution Board Missing!!!!. Please check the data and import again.",
                  { position: toast.POSITION.TOP_CENTER },
                );
              }
            }
          }
          setIsLoading(false);
        };

        if (ext === "csv") {
          handleCSVParse(file, processParsed);
        } else if (ext === "xls" || ext === "xlsx") {
          await handleExcelParse(file, processParsed);
        } else {
          setIsLoading(false);
          alert("Unsupported file format");
        }
      } catch (err) {
        console.error("handleFileUpload error:", err);
        setIsLoading(false);
      }
    },
    [
      appendDistributionBoard,
      distributionBoard,
      errorMessage,
      handleCSVParse,
      handleExcelParse,
      siteDetails,
      validateHeaders,
      state,
    ],
  );

  /*******************
   * Save / Import handler (uploads file to S3 and creates importLogs)
   *******************/
  const handleSave = useCallback(async () => {
    if (!filename) {
      toast.info("File not selected", { position: toast.POSITION.TOP_CENTER });
      return;
    }
    try {
      setIsLoading(true);
      const dateTimeISO = new Date().toISOString();

      // save original file into S3 (FILES path) - keeping same behavior
      const fileNamespace = filename.name.replace(/\s+/g, "");
      await uploadToS3({
        bucket: S3_BUCKET,
        key: `public/import/${FILES}/${fileNamespace}`,
        fileObj: filename,
      });

      // create import log
      const sourcefilelocation = [
        { fileName: fileNamespace, type: filename.type },
      ];
      const importLogs = await client.graphql({
        query: mutations.createImportLogs,
        variables: {
          input: {
            dataType: "Assets",
            sourceFileLocation: sourcefilelocation,
            impotedBy: LoginUserDetails.id,
            categoryId: state?.category?.id,
          },
        },
        authMode: "API_KEY",
      });

      const importLogObj = importLogs?.data?.createImportLogs;
      if (!importLogObj) {
        setIsLoading(false);
        return;
      }
      setImportlogid(importLogObj.id);

      // rename file by appending import id
      const fileSplit = fileNamespace.split(".");
      const tranfereId = importLogObj.id.replace("-", "_");
      const newFileName = `${fileSplit[0]}_${tranfereId}.${fileSplit[1]}`;

      // put file to ASSETIMPORT_S3_BUCKET with new name
      await uploadToS3({
        bucket: ASSETIMPORT_S3_BUCKET,
        key: newFileName,
        fileObj: filename,
      });

      // on completion show toast and clear local state (mirrors original behavior)
      const dataCount = parseInt(fileData.length || 0);
      toast.success(
        `${dataCount} Assets are queued to import. Once import is completed we will notify through email to ${email}.`,
        {
          position: toast.POSITION.TOP_CENTER,
          autoClose: false,
        },
      );
      setFileData([]);
      setFileHeader([]);
      setTableColumnLength([]);
      setIsLoading(false);
      // navigate back to assets
      navigate(`${process.env.PUBLIC_URL}/assets`, {
        state: { category: state?.category, site: state?.site },
      });
    } catch (err) {
      console.error("handleSave error:", err);
      setIsLoading(false);
    }
  }, [
    filename,
    uploadToS3,
    LoginUserDetails.id,
    state,
    fileData.length,
    email,
    navigate,
  ]);

  /*******************
   * Export handler
   *******************/
  const handleExport = useCallback(async (tblName) => {
    try {
      if (tblName === "Logbook") {
        const elt = document.getElementById(tblName);
        const wb = XLSX.utils.table_to_book(elt, { sheet: "sheet1" });
        return XLSX.writeFile(wb, `${tblName}.xlsx`);
      } else {
        const result = await client.graphql({
          query: queries.listStaticForms,
          variables: { limit, filter: { formName: { eq: tblName } } },
          authMode: "API_KEY",
        });
        const fields = result?.data?.listStaticForms?.items?.[0]?.formFields;
        const dt = JSON.parse(fields || "[]");
        const elt = dt[0] || [];
        const data = XLSX.utils.json_to_sheet(elt);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, data, tblName);
        return XLSX.writeFile(wb, `${tblName}.xlsx`);
      }
    } catch (err) {
      console.error("handleExport error:", err);
    }
  }, []);

  /*******************
   * Cancel navigation
   *******************/
  const cancelForm = useCallback(() => {
    navigate(`${process.env.PUBLIC_URL}/assets`, {
      state: { category: state?.category, site: state?.site },
    });
  }, [navigate, state]);

  /*******************
   * Initial effect - loads at mount
   *******************/
  useEffect(() => {
    // Equivalent to previous `useEffect` but cleaned up
    let mounted = true;
    (async () => {
      try {
        console.log("location state:", state);
        if (!state) {
          setDBError("disabled");
          setErrorMessage1(true);
          return;
        }
        setDBError("");
        setErrorMessage1(false);

        // load site details either from localStorage or via API
        const cachedSite = localStorage.getItem("site");
        if (!cachedSite) {
          if (LoginUserGroup === "site_user") {
            const suSites = await fetchSiteDetailsSU();
            // get templates using fetched sites
            if (suSites && suSites.length) await getAssetTemplate(suSites);
          } else {
            await fetchSiteDetailsAO();
            const activeSites = JSON.parse(
              base64.decode(
                localStorage.getItem("site") ||
                  base64.encode(JSON.stringify([])),
              ),
            );
            if (activeSites.length)
              await getAssetTemplate(
                activeSites.filter((s) => s.status === "Active"),
              );
          }
        } else {
          const activeSites = JSON.parse(base64.decode(cachedSite)).filter(
            (s) => s.status === "Active",
          );
          setSiteDetails(activeSites);
          await getAssetTemplate(activeSites);
        }

        // distribution board: either localStorage or fetch
        const cachedDB = localStorage.getItem("siteDB");
        if (!cachedDB) {
          const sites = JSON.parse(
            base64.decode(
              localStorage.getItem("site") || base64.encode(JSON.stringify([])),
            ),
          );
          const activeSites = Array.isArray(sites)
            ? sites.filter((s) => s.status === "Active")
            : [];
          await getDistributionBoardFromActiveSites(activeSites);
        } else {
          const DB = JSON.parse(base64.decode(cachedDB));
          setDistributionBoard(DB);
        }
        // kick off other fetches
        await fetchLogbooks();
        await fetchEmailId();
        await fetchAssetsData();
      } catch (err) {
        console.error("initial effect error:", err);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [
    state,
    LoginUserGroup,
    fetchSiteDetailsSU,
    fetchSiteDetailsAO,
    getAssetTemplate,
    getDistributionBoardFromActiveSites,
    fetchLogbooks,
    fetchEmailId,
    fetchAssetsData,
  ]);

  /*******************
   * Render
   *******************/
  const renderList = (
    <Fragment>
      <Container fluid className="ecommerce-dash">
        <br />
        <Col md="12" className="project-list">
          <Card className="custom-card">
            <CardHeader>
              <Col md="12" className="text-end">
                {state?.category && state?.site ? (
                  <Btn attrBtn={{ color: "primary", onClick: cancelForm }}>
                    Back
                  </Btn>
                ) : null}
              </Col>
              {state?.category ? (
                <H3>Bulk Import For {state.category.categoryName}</H3>
              ) : null}
              {state?.category ? (
                <span className="d-block">
                  Import Logbook for{" "}
                  {state.category.categoryName === "Emergency Lights" ? (
                    <a
                      className="downloadLink"
                      onClick={() => handleExport("emergencylights")}
                    >
                      {" "}
                      Emergency Lights
                    </a>
                  ) : state.category.categoryName === "RCD's" ? (
                    <a
                      className="downloadLink"
                      onClick={() => handleExport("rcd")}
                    >
                      {" "}
                      RCD's
                    </a>
                  ) : state.category.categoryName === "Appliance Testing" ? (
                    <a
                      className="downloadLink"
                      onClick={() => handleExport("appliancetesting")}
                    >
                      {" "}
                      Appliance Testing
                    </a>
                  ) : state.category.categoryName === "Smoke Detectors" ? (
                    <a
                      className="downloadLink"
                      onClick={() => handleExport("smokedetectors")}
                    >
                      {" "}
                      Smoke Detectors
                    </a>
                  ) : (
                    <a
                      className="downloadLink"
                      onClick={() => handleExport("Logbook")}
                    >
                      {" "}
                      {state.category.categoryName}
                    </a>
                  )}
                </span>
              ) : (
                " "
              )}

              {/* hidden sample table used for export */}
              <Table
                className="table-striped table-de"
                style={{ display: "none" }}
                id="Logbook"
              >
                <thead className="custom-table-head">
                  <tr>
                    <th>siteName</th>
                    <th>distributionboard</th>
                    <th>assetDescription</th>
                    <th>assetLocation</th>
                    <th>assetMake</th>
                    <th>assetModel</th>
                    <th>fittingNumber</th>
                    <th>assettemplate</th>
                    <th>assetWarrantyStart</th>
                    <th>assetWarrantyEnd</th>
                    <th>installedOn</th>
                    <th>
                      Any custom label for the{" "}
                      {state?.category?.categoryName
                        ? state.category.categoryName
                        : "Assets"}{" "}
                      Template with "custom-" as the prefix
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr />
                </tbody>
              </Table>
            </CardHeader>

            <CardBody>
              <Row>
                <Col md="5">
                  <input
                    type="file"
                    className="form-control"
                    accept=".csv,.xls,.xlsx"
                    onChange={handleFileUpload}
                  />
                </Col>

                {fileData.length > 0 && (
                  <Col md="3">
                    <span>
                      Total Assets in the uploaded file - {fileData.length}.
                    </span>
                  </Col>
                )}

                <Col md="4">
                  <Btn
                    attrBtn={{
                      color: "primary",
                      onClick: handleSave,
                      disabled: dbError,
                    }}
                  >
                    Import Logbook Details
                  </Btn>
                  {!state && (
                    <Btn
                      attrBtn={{ color: "primary", onClick: props.prevStep }}
                    >
                      Back
                    </Btn>
                  )}
                </Col>
              </Row>

              <Row>
                <Col>
                  {errorMessage && (
                    <span className="txt-danger">
                      Data Columns are not matching the sample import template.
                      Please check the sample import template by downloading.
                    </span>
                  )}
                </Col>
              </Row>

              <Row>
                <Col>
                  {errorMessage1 && (
                    <span className="txt-danger">
                      No category selected. Please select a category from the{" "}
                      <Link to={`/catassetlist`}> Assets menu</Link> and then
                      retry the import.
                    </span>
                  )}
                </Col>
              </Row>

              {/* preview table commented out intentionally as original */}
              {/* Uncomment if preview is required */}
              {/* {fileData.length > 0 && (
                <Row>
                  <Col md="12">
                    <Table className="table-striped  table-de">
                      <thead className="custom-table-head"><tr key="header">{tableColumnLength.map((key) => <th key={key}>{key}</th>)}</tr></thead>
                      <tbody>{fileData.map((item, i) => <tr key={i}>{Object.values(item).map((val, idx) => <td key={idx}>{val}</td>)}</tr>)}</tbody>
                    </Table>
                  </Col>
                </Row>
              )} */}
            </CardBody>
          </Card>
        </Col>
      </Container>
    </Fragment>
  );

  return <div>{isLoading ? <LoadingSpinner /> : renderList}</div>;
};

export default LogbookAssetDetails;
